module.exports = __webpack_public_path__ + "static/banner-img1-a4ed4e991a66d374b27fbc545b7288b7.png";